import { Dayjs } from 'dayjs';
import { isHoliday } from './holidays';

export const isWeekendDay = (d: Dayjs): boolean => {
    const day = d.get('day');
    return day === 0 || day === 6;
};

export const isBusinessDay = (d: Dayjs): boolean => {
    return !isWeekendDay(d) && !isHoliday(d);
};

/**
 * If the start date is a business day, the start date is returned.
 * Otherwise, the next business day is returned.
 */
export const getFirstBusinessDay = (dt: Dayjs): Dayjs => {
    // If this is not a business day, continue adding days until one is found
    while (!isBusinessDay(dt)) {
        dt = dt.add(1, 'day');
    }
    return dt;
};

export const addBusinessDays = (dt: Dayjs, businessDays: number): Dayjs => {
    let businessDaysCount = 0;
    // If this is not a business day, continue adding days until one is found
    while (businessDaysCount < businessDays) {
        dt = dt.add(1, 'day');
        if (isBusinessDay(dt)) {
            businessDaysCount += 1;
        }
    }
    return dt;
};
